function AdminLoadingState() {
  return <div className="mx-auto w-[min(960px,calc(100%-40px))] py-10">Laster admin...</div>;
}

export default AdminLoadingState;